import React, { useEffect, cloneElement, Fragment, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import _ from 'lodash';
import { setAnsweringQuestionsAction, clearAnsweringQuestionsAction } from "../../../../redux/answeringQuestions/answeringQuestions";
import { clearTimeCountAction } from "../../../../redux/answeringQuestions/timeCount";
import { clearQuestionViewAction } from "../../../../redux/answeringQuestions/questionView";
import Closer from "./Closer";
import Viewer from "../../learning/container/Viewer";
import QuestionTipHider from "../../learning/container/QuestionTipHider";
import ScribbleCleaner from "../../learning/container/ScribbleCleaner";
import ScribbleErase from "../../learning/container/ScribbleErase";
import GrammarReducer from "../../learning/container/GrammarReducer";
import Scribbler from "../../learning/container/Scribbler";
import KeypadShower from "../../learning/container/KeypadShower";
import Inputer from "../../learning/container/Inputer";
import KeyPresser from "../../learning/container/KeyPresser";
import KeyClicker from "../../learning/container/KeyClicker";
import NoteTaker from "../../learning/container/NoteTaker";
import AnswerEditorController from "../../learning/container/AnswerEditorController";
import Submitter from "./Submitter";
import NotEnteredAnswerChecker from "./NotEnteredAnswerChecker";
import OXPopupHider from "../../questionInspection/container/OXPopupHider";
import Jumper from "../../questionInspection/container/Jumper";
import { useAmplitude } from "../../../../hooks";

const AnsweringQuestionsInitializer = (props) => {

  const dispatch = useDispatch();
  const setAnsweringQuestions = payload => { dispatch(setAnsweringQuestionsAction(payload)) };
  const clearAnsweringQuestions = () => { dispatch(clearAnsweringQuestionsAction()) };
  const clearTimeCount = () => { dispatch(clearTimeCountAction()) };
  const clearQuestionView = () => { dispatch(clearQuestionViewAction()) };

  const location = useLocation();
  const { setAmplitudeLog } = useAmplitude();

  useEffect(() => {
    setAnsweringQuestions({
      data: _.find(location.state.data, (o) => o.qstCd === location.state.choiceQstCd),
      answeringCount: location.state.index + 1,
      listData: location.state.data
    });


    logger();

    return () => {
      clearAnsweringQuestions();
      clearTimeCount();
      clearQuestionView();
    };
  }, []);

  // 오답 다시풀기 시작, 풀기 완료 amplitude logger
  const logger = useCallback((item) => {
    let logData = item;
    const { data = null, index = -1 } = location.state;
    if (!item) {
      if (!data) return;
      logData = data[index];
    }

    setAmplitudeLog({
      eventName: {
        name: item ? '오답다시풀기 완료' : '오답다시풀기 시작',
        event: {
          '커리큘럼그룹': logData.thmaNm,
          '커리큘럼명': logData.stepNm,
          '소주제이름': logData.stgNm,
          '소주제코드': logData.stgCd,
          '문항코드': logData.qstCd,
        }
      }
    });

    const dom = document.querySelector('.qa-cnt-wrap span');

    if (item && dom) {
      const index = Number(dom.innerHTML);
      
      // 마지막 문항일 때 제외
      if (data[data.length - 1].qstCd === logData.qstCd) return;
      
      logData = data[index - 1];

      setAmplitudeLog({
        eventName: {
          name: '오답다시풀기 시작',
          event: {
            '커리큘럼그룹': logData.thmaNm,
            '커리큘럼명': logData.stepNm,
            '소주제이름': logData.stgNm,
            '소주제코드': logData.stgCd,
            '문항코드': logData.qstCd,
          }
        }
      });
    }

  }, []);

  return cloneElement(props.children || <Fragment />, {
    Closer,
    Viewer,
    QuestionTipHider,
    ScribbleCleaner,
    ScribbleErase,
    GrammarReducer,
    Scribbler,
    KeypadShower,
    Inputer,
    KeyPresser,
    KeyClicker,
    NoteTaker,
    AnswerEditorController,
    Submitter,
    NotEnteredAnswerChecker,
    OXPopupHider,
    Jumper,
    Logger: logger
  });

};

export default AnsweringQuestionsInitializer;
